/**
 * 汎用ユーティルクラス 
 */

export default {
  name: "util",
  methods: {
    eq: (o1, o2) => {
      return o1 == o2 ? true : false;
    },
    notEq: (o1, o2) => {
      return o1 != o2 ? true : false;
    },
    isEmpty: (o) => {
      if (o == null) {
        return true;
      }
      if (typeof o == "string") {
        return o == null || o == "undefined" || o == "" ? true : false;
      }
      else if (typeof o == "object") {
        return o == null ? true : false;
      }
      else if (typeof o == "undefined") {
        return true;
      }
    },
    isNotEmpty: (o) => {
      if (o == null) {
        return false;
      }
      if (typeof o == "string") {
        return o == null || o == "undefined" || o == "" ? false : true;
      }
      else if (typeof o == "object") {
        return o == null ? false : true;
      }
      else if (typeof o == "undefined") {
        return false;
      }
    },
    getFirstDate: (date) => {
      return new Date(date.getFullYear(), date.getMonth(), 1);
    },
    getLastDate: (date) => {
      return new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999);
    },
    getFirstOfDay: (date) => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },
    getLastOfDay: (date) => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
    },
    formatDateTime: (date) => {
      return date.getFullYear()
        + "-"
        + ("0" + (date.getMonth() + 1)).slice(-2)
        + "-"
        + ("0" + date.getDate()).slice(-2)
        + " "
        + ("0" + date.getHours()).slice(-2)
        + ":"
        + ("0" + date.getMinutes()).slice(-2);
    },
    escapeNull: (o) => {
      if (o == null) {
        return "";
      }
      if (typeof o == "string" && (o == null || o == "undefined" || o == "")) {
        return "";
      }
      else if (typeof o == "object" && o == null) {
        return "";
      }
      else if (typeof o == "undefined") {
        return "";
      }
      return o;
    },
    setTextWithCode(code, value, decimal = true) {
      if (value !== undefined) {
        if (decimal) {
          value = this.setTextWithDecimalValue(value);
        }
        if (code == "0") {
          value = "+" + value;
        } else {
          value = "-" + value;
        }
        return value;
      }
    },
    setTextWithDecimalValue(value) {
      if (value == undefined) {
        return "";
      }
      else if (value == "0")
        return "0.00";
      else {
        let start = value.slice(
          0,
          value.length - 2
        );
        let end = value.slice(value.length - 2);
        return start + "." + end;
      }
    },
  },
}